import React from "react"; // Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"; // Import Swiper styles
import "swiper/css";
import "swiper/css/pagination"; // import required modules
import { Autoplay, Pagination } from "swiper/modules";

export default function Hero() {
  return (
    <Swiper
      spaceBetween={30}
      pagination={{
        clickable: true,
      }}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      loop={true}
      modules={[Pagination, Autoplay]}
      className="mySwiper"
    >
      <SwiperSlide>
        <div
          className={`flex items-center w-full h-full bg-cover bg-no-repeat bg-[url("/src/Components/Images/slide-img.png")]`}
        >
          <div className="max-w-[600px] flex items-center justify-center ml-[100px]">
            <div className="flex-col">
              <h1 className="text-white text-[64px] font-bold mb-3">
                lorem <span className="text-orange-500">ipsum</span> lorem
              </h1>
              <p className="text-[18px] text-white mb-9">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries.
              </p>
              <button className="rounded-2xl flex bg-amber-500 text-white font-semibold px-8 py-4 capitalize">
                visit website
              </button>
            </div>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>Slide 2</SwiperSlide>
      <SwiperSlide>Slide 3</SwiperSlide>
      <SwiperSlide>Slide 4</SwiperSlide>
    </Swiper>
  );
}
